import React from 'react';
import { FiCheckCircle, FiClock } from 'react-icons/fi';
import { API_BASE_URL } from '../../../utils/api';

export default function SubmissionsTable({ submissions }) {
    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50">
                <h3 className="font-bold text-gray-800 text-sm uppercase tracking-wider">Recent Submissions</h3>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead>
                        <tr className="text-xs font-bold text-gray-400 uppercase tracking-widest border-b border-gray-50">
                            <th className="px-6 py-4">Submission Date</th>
                            <th className="px-6 py-4">Course / Month</th>
                            <th className="px-6 py-4">Amount</th>
                            <th className="px-6 py-4">Status</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                        {submissions.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="px-6 py-8 text-center text-gray-400 text-sm italic">
                                    No submissions found
                                </td>
                            </tr>
                        ) : submissions.map((sub) => (
                            <tr key={sub.id} className="hover:bg-gray-50/50 transition-colors">
                                <td className="px-6 py-4 text-sm font-medium text-gray-600">
                                    {new Date(sub.created_at).toLocaleDateString()}
                                </td>
                                <td className="px-6 py-4">
                                    <p className="text-sm font-bold text-gray-900">{sub.class_name}</p>
                                    <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wide">{sub.month_name}</p>
                                </td>
                                <td className="px-6 py-4 text-sm font-bold text-gray-900">LKR {sub.amount}</td>
                                <td className="px-6 py-4">
                                    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider ${sub.status === 'Approved' ? 'bg-green-100 text-green-700' :
                                        sub.status === 'Rejected' ? 'bg-red-100 text-red-700' :
                                            'bg-blue-100 text-blue-700'
                                        }`}>
                                        {sub.status === 'Approved' ? <FiCheckCircle /> : <FiClock />}
                                        {sub.status}
                                    </span>
                                    {sub.slip_url && (
                                        <button
                                            onClick={() => window.open(`${API_BASE_URL}/${sub.slip_url}`, '_blank')}
                                            className="ml-4 text-blue-600 hover:text-blue-700 text-[10px] font-bold uppercase tracking-wider underline"
                                        >
                                            View Slip
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
